var _a;
import { __extends } from "tslib";
import React, { Component } from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import Grid from './internal/GridElement';
import { defaultGridColumns } from './internal/vars';
export default withTheme((_a = /** @class */ (function (_super) {
        __extends(AkGrid, _super);
        function AkGrid() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getTheme = function (props) { return ({
                columns: props.theme && props.theme.columns
                    ? props.theme.columns
                    : defaultGridColumns,
                spacing: props.theme && props.theme.spacing
                    ? props.theme.spacing
                    : props.spacing,
                isNestedGrid: props.theme && props.theme.isNestedGrid
                    ? props.theme.isNestedGrid
                    : false,
            }); };
            return _this;
        }
        AkGrid.prototype.render = function () {
            var _a = this.props, layout = _a.layout, spacing = _a.spacing, testId = _a.testId;
            return (React.createElement(ThemeProvider, { theme: this.getTheme(this.props) },
                React.createElement(Grid, { "data-testid": testId, spacing: spacing, layout: layout }, this.props.children)));
        };
        return AkGrid;
    }(Component)),
    _a.defaultProps = {
        spacing: 'cosy',
        layout: 'fixed',
    },
    _a));
//# sourceMappingURL=Grid.js.map